import React from 'react'

import { PipelineStepType } from '../pipelineBuilder.types'
import { ApplicationStepPanel } from './ApplicationStepPanel'
import { DefaultStepPanel } from './DefaultStepPanel'
import { LeadsStepPanel } from './LeadsStepPanel'
import { ProspectsStepPanel } from './ProspectsStepPanel'
import { ScreeningStepPanel } from './ScreeningStepPanel'

export { ApplicationStepPanel } from './ApplicationStepPanel'
export { DefaultStepPanel } from './DefaultStepPanel'
export { LeadsStepPanel } from './LeadsStepPanel'
export { ProspectsStepPanel } from './ProspectsStepPanel'
export { ScreeningStepPanel } from './ScreeningStepPanel'

export const STEP_PANEL_REGISTRY: Partial<
    Record<
        PipelineStepType,
        React.FC<import('../pipelineBuilder.types').StepEditPanelProps>
    >
> = {
    prospects: ProspectsStepPanel,
    leads: LeadsStepPanel,
    application: ApplicationStepPanel,
    screening: ScreeningStepPanel,
}

export function getStepPanel(
    type: PipelineStepType,
): React.FC<import('../pipelineBuilder.types').StepEditPanelProps> {
    return STEP_PANEL_REGISTRY[type] ?? DefaultStepPanel
}
